import { Box, useToken } from '@chakra-ui/react';
import {
  PRODUCT_LINE_ITEM_GAP,
  PRODUCT_LINE_ITEM_IMAGE_SIZE,
  ProductAccordion,
  ProductBulletPointsSmall,
  TextLink,
} from '@time-line/components/common';
import { RichTextResolver } from 'components/common/RichTextResolver';
import type { ProductAccordionContent } from 'hooks/product/useProductAccordionContent';
import { useIsPdp } from 'hooks/useIsPdp';
import { useIsSkincare } from 'hooks/useIsSkincare';
import { SCIENCE, SKINCARE_SCIENCE } from 'lib/constants/routes';
import { getIngredientsAccordionCopy } from 'utils/product/getIngredientsAccordionCopy';

interface BundleAccordionItemContentProps {
  accordionContent: ProductAccordionContent;
}

export function BundleAccordionItemContent({
  accordionContent,
}: BundleAccordionItemContentProps) {
  const [gap] = useToken('space', [PRODUCT_LINE_ITEM_GAP]);
  const isSkincare = useIsSkincare();
  const isPdp = useIsPdp();

  return (
    <Box pl={`calc(${PRODUCT_LINE_ITEM_IMAGE_SIZE} + ${gap})`}>
      {accordionContent.bulletPoints && (
        <Box mb="xs">
          <RichTextResolver
            blocks={accordionContent.bulletPoints}
            container={ProductBulletPointsSmall}
          />
        </Box>
      )}
      <ProductAccordion
        iconVariant="caret"
        title={accordionContent.title}
        howToUseV2={accordionContent.howToUseV2}
        ingredients={accordionContent.ingredients}
        informationPanel={accordionContent.informationPanel}
        scienceHref={isSkincare ? SKINCARE_SCIENCE : SCIENCE}
        {...getIngredientsAccordionCopy(accordionContent.productType)}
        RichTextResolver={RichTextResolver}
      />
      {isPdp && (
        <TextLink
          href={accordionContent.href}
          variant="underline"
          textProps={{ size: 'overline' }}
          target="_blank"
        >
          Full product details
        </TextLink>
      )}
    </Box>
  );
}
